import React, { useEffect, useState } from 'react';
import { getCredentialsIntegration } from '../../../api/api';
import ItemInfo from './ItemInfo';
import { useCopyText } from '../../../hooks';

const CredentialsInfo = ({ integration_id }) => {
  const [credentials, setCredentials] = useState(null); // состояние для данных
  const handleCopy = useCopyText();

  useEffect(() => {
    if (integration_id) {
      const getCredentials = async () => {
        await getCredentialsIntegration({ integration_id, dataCb: (data) => setCredentials(data) });
      };
      getCredentials();
    }
  }, [integration_id]);

  return (
    <>
      <ItemInfo
        className={'my-4'}
        title={'Логин'}
        text={credentials?.login ? '*********' : '-'}
        handler={() => handleCopy(credentials?.login, 'Логин скопирован')}
      />
      <ItemInfo
        title={'Пароль'}
        className={'mb-6'}
        text={credentials?.password ? '*********' : '-'}
        handler={() => handleCopy(credentials?.password, 'Пароль скопирован')}
      />
    </>
  );
};

export default CredentialsInfo;
